"use client";
/* Auto-generated. Do not edit. */
/* Source: src/pages/home-modules/home-eleven/sections/servicesSection.tsx */

import { SmartImage } from "@/Components";
import { SmartLink } from "@/Components";
import { renderCollectionNode, renderItemNode, renderNode } from "@/Templates/section-node-renderers";
import { FC, ComponentProps, Key, ReactNode } from "react";

type ServicesSectionAccordionsItem = {
    key: Key | null | undefined;
    /** Detected variants: "accordion-collapse collapse show" | "accordion-collapse collapse" */
    className: string;
    /** Detected variants: "/Templates/Doccure/img/about/faq-img-1.jpg" | "/Templates/Doccure/img/about/faq-img-2.jpg" | "/Templates/Doccure/img/about/faq-img-3.jpg" | "/Templates/Doccure/img/about/faq-img-4.jpg" */
    src: string;
    /** Detected variants: "collapseOne" | "collapseTwo" | "collapseThree" | "collapseFour" */
    id: string;
    /** Detected variants: "headingOne" | "headingTwo" | "headingThree" | "headingFour" */
    h30Id: string;
    /** Detected variants: "01. Facial Aesthetic Procedures" | "02. Body Contoure Treatments" | "03. Skin Rejuvenation Solutions" | "04. Aesthetic Breast Makeover" */
    link0Text: ReactNode;
    /** Detected variants: "collapseOne" | "collapseTwo" | "collapseThree" | "collapseFour" */
    ariaControls: string;
    /** Detected variants: "true" | "false" */
    ariaExpanded: boolean;
    /** Detected variants: "accordion-button" | "accordion-button collapsed" */
    link0ClassName: string;
    /** Detected variants: "#collapseOne" | "#collapseTwo" | "#collapseThree" | "#collapseFour" */
    dataBsTarget: string;
    /** Detected variants: "Enhancing facial harmony through advanced cosmetic for natural, youthful results." | "Shaping and sculpting the body with safe, modern surgical and non-surgical methods." | "Improving texture, tone, with personalized, dermatologist-approved treatments." | "Offering natural-looking augmentation, reduction, performed with expert precision." */
    span0Text: ReactNode;
    /** Detected variants: "accordion-item" */
    divClassName?: string;
    /** Detected variants: "#faq-details-one" */
    dataBsParent?: string;
    /** Detected variants: "accordion-body" */
    div0ClassName?: string;
    /** Detected variants: "accordion-content" */
    div0ClassName2?: string;
    /** Detected variants: "service-img" */
    alt?: string;
    /** Detected variants: "img-fluid img-1" */
    imageWithBasePath0ClassName?: string;
    /** Detected variants: "accordion-header" */
    h30ClassName?: string;
    /** Detected variants: "collapse" */
    dataBsToggle?: string;
    /** Detected variants: "#" */
    href?: string;
    /** Detected variants: "shadow" */
    imageWithBasePath0Alt?: string;
    /** Detected variants: "img-fluid shdaow-1" */
    imageWithBasePath0ClassName2?: string;
    /** Detected variants: "/Templates/Doccure/img/icons/faq-shadow-1.png" */
    imageWithBasePath0Src?: string;
    /** Detected variants: "shadow" */
    imageWithBasePath1Alt?: string;
    /** Detected variants: "img-fluid shdaow-2" */
    imageWithBasePath1ClassName?: string;
    /** Detected variants: "/Templates/Doccure/img/icons/faq-shadow-2.png" */
    imageWithBasePath1Src?: string;
    /** Detected variants: "text" */
    span0ClassName?: string;
    /** Detected variants: "icon" */
    span1ClassName?: string;
    /** Detected variants: "isax isax-arrow-right-1" */
    i0ClassName?: string;
};
export type HomeElevenServicesSectionGeneratedProps = {
    divDiv0Div0Div0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: ServicesSectionAccordionsItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    divH30H3Props?: Partial<ComponentProps<"h3">> | ((item: ServicesSectionAccordionsItem) => Partial<ComponentProps<"h3">>);
    divH30Link0LinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: ServicesSectionAccordionsItem) => Partial<ComponentProps<typeof SmartLink>>);
    divH30Link0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: ServicesSectionAccordionsItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    divH30Link0ImageWithBasePath1ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: ServicesSectionAccordionsItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    /** Default: "1s" */
    sectionDiv0Div0DivDataWowDuration?: string;
    /** Default: "Services" */
    sectionDiv0Div0Div0DivText?: ReactNode;
    /** Default: "arrow" */
    sectionDiv0Div0Div0ImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/icons/arrow-left.svg" */
    sectionDiv0Div0Div0ImageWithBasePath0ImageSrc?: string;
    sectionDiv0Div0Div0ImageWithBasePath0ImageVisible?: boolean;
    sectionDiv0Div0Div0ImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Div0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "arrow" */
    sectionDiv0Div0Div0ImageWithBasePath1ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/icons/arrow-right.svg" */
    sectionDiv0Div0Div0ImageWithBasePath1ImageSrc?: string;
    sectionDiv0Div0Div0ImageWithBasePath1ImageVisible?: boolean;
    sectionDiv0Div0Div0ImageWithBasePath1ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Div0ImageWithBasePath1ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "Creative Best Services" */
    sectionDiv0Div0H20H2Text?: ReactNode;
    sectionDiv0Div0H20H2Visible?: boolean;
    sectionDiv0Div0H20H2Renderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0H20H2Props?: Partial<ComponentProps<"h2">>;
    /** Default: "faq-details-one" */
    sectionDiv0Div1DivId?: string;
    /** Default: "#" */
    sectionDiv0Div2Link0LinkHref?: string;
    /** Default: "View All Services" */
    sectionDiv0Div2Link0LinkText?: ReactNode;
    sectionDiv0Div2Link0LinkVisible?: boolean;
    sectionDiv0Div2Link0LinkRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div2Link0LinkProps?: Partial<ComponentProps<typeof SmartLink>>;
    /** Default: "service-icon" */
    sectionImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/icons/services-icon-one.png" */
    sectionImageWithBasePath0ImageSrc?: string;
    sectionImageWithBasePath0ImageVisible?: boolean;
    sectionImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "service-icon" */
    sectionImageWithBasePath1ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/icons/services-icon-two.png" */
    sectionImageWithBasePath1ImageSrc?: string;
    sectionImageWithBasePath1ImageVisible?: boolean;
    sectionImageWithBasePath1ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionImageWithBasePath1ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    servicesSectionAccordions: ServicesSectionAccordionsItem[];
    servicesSectionAccordionsItemWrapper?: (item: ServicesSectionAccordionsItem, content: ReactNode) => ReactNode;
    servicesSectionAccordionsRenderer?: (defaultNode: ReactNode) => ReactNode;
    servicesSectionAccordionsLinkVisible?: boolean;
    servicesSectionAccordionsLinkRenderer?: (item: ServicesSectionAccordionsItem, defaultNode: ReactNode) => ReactNode;
    servicesSectionAccordionsImageVisible?: boolean;
    servicesSectionAccordionsImageRenderer?: (item: ServicesSectionAccordionsItem, defaultNode: ReactNode) => ReactNode;
    servicesSectionAccordionsH3Visible?: boolean;
    servicesSectionAccordionsH3Renderer?: (item: ServicesSectionAccordionsItem, defaultNode: ReactNode) => ReactNode;
    servicesSectionAccordionsLinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: ServicesSectionAccordionsItem) => Partial<ComponentProps<typeof SmartLink>>);
    servicesSectionAccordionsImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: ServicesSectionAccordionsItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    servicesSectionAccordionsH3Props?: Partial<ComponentProps<"h3">> | ((item: ServicesSectionAccordionsItem) => Partial<ComponentProps<"h3">>);
};

const HomeElevenServicesSectionGenerated: FC<HomeElevenServicesSectionGeneratedProps> = ({
    sectionDiv0Div0Div0DivText = "Services",
    sectionDiv0Div0Div0ImageWithBasePath0ImageAlt = "arrow",
    sectionDiv0Div0Div0ImageWithBasePath0ImageSrc = "/Templates/Doccure/img/icons/arrow-left.svg",
    sectionDiv0Div0Div0ImageWithBasePath0ImageVisible,
    sectionDiv0Div0Div0ImageWithBasePath0ImageRenderer,
    sectionDiv0Div0Div0ImageWithBasePath0ImageProps,
    sectionDiv0Div0Div0ImageWithBasePath1ImageAlt = "arrow",
    sectionDiv0Div0Div0ImageWithBasePath1ImageSrc = "/Templates/Doccure/img/icons/arrow-right.svg",
    sectionDiv0Div0Div0ImageWithBasePath1ImageVisible,
    sectionDiv0Div0Div0ImageWithBasePath1ImageRenderer,
    sectionDiv0Div0Div0ImageWithBasePath1ImageProps,
    sectionDiv0Div0DivDataWowDuration = "1s",
    sectionDiv0Div0H20H2Text = "Creative Best Services",
    sectionDiv0Div0H20H2Visible,
    sectionDiv0Div0H20H2Renderer,
    sectionDiv0Div0H20H2Props,
    sectionDiv0Div1DivId = "faq-details-one",
    sectionDiv0Div2Link0LinkHref = "#",
    sectionDiv0Div2Link0LinkText = "View All Services",
    sectionDiv0Div2Link0LinkVisible,
    sectionDiv0Div2Link0LinkRenderer,
    sectionDiv0Div2Link0LinkProps,
    sectionImageWithBasePath0ImageAlt = "service-icon",
    sectionImageWithBasePath0ImageSrc = "/Templates/Doccure/img/icons/services-icon-one.png",
    sectionImageWithBasePath0ImageVisible,
    sectionImageWithBasePath0ImageRenderer,
    sectionImageWithBasePath0ImageProps,
    sectionImageWithBasePath1ImageAlt = "service-icon",
    sectionImageWithBasePath1ImageSrc = "/Templates/Doccure/img/icons/services-icon-two.png",
    sectionImageWithBasePath1ImageVisible,
    sectionImageWithBasePath1ImageRenderer,
    sectionImageWithBasePath1ImageProps,
    divDiv0Div0Div0ImageWithBasePath0ImageProps,
    divH30H3Props,
    divH30Link0ImageWithBasePath0ImageProps,
    divH30Link0ImageWithBasePath1ImageProps,
    divH30Link0LinkProps,
    servicesSectionAccordions,
    servicesSectionAccordionsItemWrapper,
    servicesSectionAccordionsRenderer,
    servicesSectionAccordionsLinkVisible,
    servicesSectionAccordionsLinkRenderer,
    servicesSectionAccordionsImageVisible,
    servicesSectionAccordionsImageRenderer,
    servicesSectionAccordionsH3Visible,
    servicesSectionAccordionsH3Renderer,
    servicesSectionAccordionsLinkProps,
    servicesSectionAccordionsImageProps,
    servicesSectionAccordionsH3Props,
}) => {
    return (
        <section className="services-section-eleven section">
            <div className="container">
                <div className="section-header section-header-eleven text-center wow fadeInUp" data-wow-duration={sectionDiv0Div0DivDataWowDuration}>
                    <div className="title">
                        {renderNode(sectionDiv0Div0Div0ImageWithBasePath0ImageVisible, sectionDiv0Div0Div0ImageWithBasePath0ImageRenderer, (
                            <SmartImage src={sectionDiv0Div0Div0ImageWithBasePath0ImageSrc} alt={sectionDiv0Div0Div0ImageWithBasePath0ImageAlt} className="img-fluid icon-1" {...(sectionDiv0Div0Div0ImageWithBasePath0ImageProps ?? {})} />
                        ))}
                        {sectionDiv0Div0Div0DivText}
                        {renderNode(sectionDiv0Div0Div0ImageWithBasePath1ImageVisible, sectionDiv0Div0Div0ImageWithBasePath1ImageRenderer, (
                            <SmartImage src={sectionDiv0Div0Div0ImageWithBasePath1ImageSrc} alt={sectionDiv0Div0Div0ImageWithBasePath1ImageAlt} className="img-fluid icon-2" {...(sectionDiv0Div0Div0ImageWithBasePath1ImageProps ?? {})} />
                        ))}
                    </div>
                    {renderNode(sectionDiv0Div0H20H2Visible, sectionDiv0Div0H20H2Renderer, (
                        <h2 className="section-title" {...(sectionDiv0Div0H20H2Props ?? {})}>{sectionDiv0Div0H20H2Text}</h2>
                    ))}
                </div>
                <div className="accordion" id={sectionDiv0Div1DivId}>
                    {renderCollectionNode(
                        servicesSectionAccordions,
                        (item: ServicesSectionAccordionsItem) => (
                            <div className={item.divClassName ?? "accordion-item"} key={item.key}>
                                {renderItemNode(servicesSectionAccordionsH3Visible, servicesSectionAccordionsH3Renderer, item, (
                                    <h3 className={item.h30ClassName ?? "accordion-header"} id={item.h30Id} {...(typeof servicesSectionAccordionsH3Props === "function" ? servicesSectionAccordionsH3Props(item) : (servicesSectionAccordionsH3Props ?? {}))} {...(typeof divH30H3Props === "function" ? divH30H3Props(item) : (divH30H3Props ?? {}))}>
                                        {renderItemNode(servicesSectionAccordionsLinkVisible, servicesSectionAccordionsLinkRenderer, item, (
                                            <SmartLink href={item.href ?? "#"} className={item.link0ClassName} data-bs-toggle={item.dataBsToggle ?? "collapse"} data-bs-target={item.dataBsTarget} aria-expanded={item.ariaExpanded} aria-controls={item.ariaControls} {...(typeof servicesSectionAccordionsLinkProps === "function" ? servicesSectionAccordionsLinkProps(item) : (servicesSectionAccordionsLinkProps ?? {}))} {...(typeof divH30Link0LinkProps === "function" ? divH30Link0LinkProps(item) : (divH30Link0LinkProps ?? {}))}>
                                                {item.link0Text}
                                                <span className={item.span0ClassName ?? "text"}>{item.span0Text}</span>
                                                <span className={item.span1ClassName ?? "icon"}>
                                                    {" "}
                                                    <i className={item.i0ClassName ?? "isax isax-arrow-right-1"} />
                                                    {" "}
                                                </span>
                                                {renderItemNode(servicesSectionAccordionsImageVisible, servicesSectionAccordionsImageRenderer, item, (
                                                    <SmartImage src={item.imageWithBasePath0Src ?? "/Templates/Doccure/img/icons/faq-shadow-1.png"} alt={item.imageWithBasePath0Alt ?? "shadow"} className={item.imageWithBasePath0ClassName2 ?? "img-fluid shdaow-1"} {...(typeof servicesSectionAccordionsImageProps === "function" ? servicesSectionAccordionsImageProps(item) : (servicesSectionAccordionsImageProps ?? {}))} {...(typeof divH30Link0ImageWithBasePath0ImageProps === "function" ? divH30Link0ImageWithBasePath0ImageProps(item) : (divH30Link0ImageWithBasePath0ImageProps ?? {}))} />
                                                ))}
                                                {renderItemNode(servicesSectionAccordionsImageVisible, servicesSectionAccordionsImageRenderer, item, (
                                                    <SmartImage src={item.imageWithBasePath1Src ?? "/Templates/Doccure/img/icons/faq-shadow-2.png"} alt={item.imageWithBasePath1Alt ?? "shadow"} className={item.imageWithBasePath1ClassName ?? "img-fluid shdaow-2"} {...(typeof servicesSectionAccordionsImageProps === "function" ? servicesSectionAccordionsImageProps(item) : (servicesSectionAccordionsImageProps ?? {}))} {...(typeof divH30Link0ImageWithBasePath1ImageProps === "function" ? divH30Link0ImageWithBasePath1ImageProps(item) : (divH30Link0ImageWithBasePath1ImageProps ?? {}))} />
                                                ))}
                                            </SmartLink>
                                        ))}
                                    </h3>
                                ))}
                                <div id={item.id} className={item.className} data-bs-parent={item.dataBsParent ?? "#faq-details-one"}>
                                    <div className={item.div0ClassName ?? "accordion-body"}>
                                        <div className={item.div0ClassName2 ?? "accordion-content"}>
                                            {renderItemNode(servicesSectionAccordionsImageVisible, servicesSectionAccordionsImageRenderer, item, (
                                                <SmartImage src={item.src} alt={item.alt ?? "service-img"} className={item.imageWithBasePath0ClassName ?? "img-fluid img-1"} {...(typeof servicesSectionAccordionsImageProps === "function" ? servicesSectionAccordionsImageProps(item) : (servicesSectionAccordionsImageProps ?? {}))} {...(typeof divDiv0Div0Div0ImageWithBasePath0ImageProps === "function" ? divDiv0Div0Div0ImageWithBasePath0ImageProps(item) : (divDiv0Div0Div0ImageWithBasePath0ImageProps ?? {}))} />
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ),
                        servicesSectionAccordionsItemWrapper,
                        servicesSectionAccordionsRenderer
                    )}
                </div>
                <div className="view-all text-center">
                    {renderNode(sectionDiv0Div2Link0LinkVisible, sectionDiv0Div2Link0LinkRenderer, (
                        <SmartLink href={sectionDiv0Div2Link0LinkHref} className="btn btn-primary d-inline-flex align-items-center gap-2" {...(sectionDiv0Div2Link0LinkProps ?? {})}>
                            {sectionDiv0Div2Link0LinkText}
                            <i className="isax isax-arrow-right-3" />
                        </SmartLink>
                    ))}
                </div>
            </div>
            {renderNode(sectionImageWithBasePath0ImageVisible, sectionImageWithBasePath0ImageRenderer, (
                <SmartImage src={sectionImageWithBasePath0ImageSrc} alt={sectionImageWithBasePath0ImageAlt} className="img-fluid element-1" {...(sectionImageWithBasePath0ImageProps ?? {})} />
            ))}
            {renderNode(sectionImageWithBasePath1ImageVisible, sectionImageWithBasePath1ImageRenderer, (
                <SmartImage src={sectionImageWithBasePath1ImageSrc} alt={sectionImageWithBasePath1ImageAlt} className="img-fluid element-2" {...(sectionImageWithBasePath1ImageProps ?? {})} />
            ))}
        </section>
    );
};

export default HomeElevenServicesSectionGenerated;
